import React from "react";
import { Link, useLocation } from "react-router-dom";

const FinalCTASection = ({ title, text, ctaText, rolNombre }) => {
    const location = useLocation();
    const rolParam = rolNombre ? `&rolInicial=${encodeURIComponent(rolNombre)}` : '';
    const loginUrl = `/login?redirect=${encodeURIComponent(location.pathname)}${rolParam}`;

    return (
        <section className="bg-gradient-to-r from-brand-blue to-blue-900 text-white py-20 text-center">
            <div className="max-w-5xl mx-auto px-6">
                <h2 className="text-3xl font-bold mb-4">{title}</h2>
                <p className="text-lg opacity-90 max-w-xl mx-auto mb-8">{text}</p>
                <Link
                    to={loginUrl}
                    className="inline-block bg-brand-yellow text-gray-900 px-8 py-4 rounded-lg font-bold hover:bg-yellow-500 transition-all hover:-translate-y-0.5 hover:shadow-lg"
                >
                    {ctaText}
                </Link>
            </div>
        </section>
    );
};

export default FinalCTASection;
